import React, { FC } from 'react'
import Main from './components/Main/Main'
import Header from './components/Header/Header'
import Footer from './components/Footer/Footer'
import CookieConsent from './components/CookieConsent/CookieConsent'
import './App.scss'
import 'animate.css';

const App: FC = () => {
  return (
    <>
      <Header />
      <Main />
      <Footer />
      <CookieConsent />
    </>
  )
}

export default App